import { useMemo } from 'react';

import sanitizeHtml from 'sanitize-html';

import { makeStyles } from '@gogame/ui/styles';

import { sanitizeHTML } from './helpers/sanitize';

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: '12px',
    fontFamily: "'Roboto', Helvetica, Arial, sans-serif",
    width: '100%',
    userSelect: 'text',
    flexGrow: 1,
    lineHeight: '18px',
    wordBreak: 'break-word',
    '& p': {
      margin: 0,
    },
    '& .mention': {
      color: `${theme.palette.primary.main}`,
    },
    '& blockquote': {
      borderLeft: '3px solid rgba(13,13,13,.1)',
      paddingLeft: 12,
    },
    '& strong': {
      fontWeight: 500,
    },
    '& a': {
      color: `${theme.palette.primary.main}`,
      textDecoration: 'none',
    },
    '& ul, ol': {
      margin: '8px 0',
    },
  },
  editor: {
    width: '100%',
  },
}));

export const HTMLRender = ({ value }) => {
  const classes = useStyles();
  const cleanHTML = useMemo(() => {
    return sanitizeHTML({ value });
  }, [value]);
  return (
    <div
      className={classes.root}
      dangerouslySetInnerHTML={{ __html: cleanHTML }}
    />
  );
};
